import _get from 'lodash.get';
const get = (obj, path = '', fallback) => _get(obj, path, fallback);
export default get;
